export enum MembershipUserSubscriptionStatus {
    UNKNOWN,
    CHECKOUT,
    PAID,
    DELETED, // BY STRIPE WHEN PERIOD ENDS
    CANCELLED // BY WILD
}